module.exports = __webpack_public_path__ + "static/img/how-to-join-step-3.79ecdbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/how-to-join-step-3.png
// module id = IsKs
// module chunks = 1